import * as __plugin from '@/plugins/modal-manager/plugin';
export * from '@/plugins/modal-manager/modal';
export * from '@/plugins/modal-manager/modal-manager';
export * from '@/plugins/modal-manager/modal-spawn-agent';
export default __plugin.default;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/plugins/modal-manager/index.ts